import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'

export default class Trellotemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Trello",
        content: [
        "Overview of Trello and its features",
        "Understanding boards, lists, and cards",
        "Creating and organizing boards",
        "Collaborating with team members",
        "Using Trello for project management"
        ]
        },
        {
        title: "Trello Basics",
        content: [
        "Creating and managing boards, lists, and cards",
        "Customizing cards and lists with labels and stickers",
        "Adding due dates, attachments, and checklists",
        "Using power-ups to extend Trello functionality",
        "Collaborating with team members using comments and mentions"
        ]
        },
        {
        title: "Trello Workflow",
        content: [
        "Creating and managing templates",
        "Using Butler for automation and workflow optimization",
        "Managing tasks and deadlines",
        "Tracking progress with Trello reports and analytics",
        "Using Trello for agile development"
        ]
        },
        {
        title: "Trello Integrations",
        content: [
        "Integrating Trello with other tools and applications",
        "Using Trello with Google Drive, Slack, and other platforms",
        "Creating custom integrations with Trello's API",
        "Managing data and access permissions",
        "Using Trello for cross-functional team collaboration"
        ]
        },
        {
        title: "Advanced Trello",
        content: [
        "Managing complex projects with Trello",
        "Using Trello for sales and marketing",
        "Creating and managing boards for remote teams",
        "Optimizing Trello performance and security",
        "Scaling Trello for enterprise use"
        ]
        },
        {
        title: "Trello for Personal Productivity",
        content: [
        "Using Trello for personal task and project management",
        "Creating and managing boards for personal goals",
        "Managing daily routines and habits with Trello",
        "Using Trello for time management and productivity",
        "Integrating Trello with personal apps and tools"
        ]
        },
        {
        title: "Trello for Education",
        content: [
        "Using Trello for classroom organization and management",
        "Creating and managing boards for lesson plans and assignments",
        "Collaborating with students and educators using Trello",
        "Using Trello for project-based learning",
        "Integrating Trello with educational technology"
        ]
        },
        {
        title: "Trello for Nonprofits",
        content: [
        "Using Trello for nonprofit project management",
        "Creating and managing boards for fundraising and events",
        "Collaborating with volunteers and stakeholders using Trello",
        "Using Trello for nonprofit campaigns and advocacy",
        "Integrating Trello with nonprofit software and tools"
        ]
        },
        {
        title: "Trello for Remote Work",
        content: [
        "Managing remote teams with Trello",
        "Using Trello for virtual meetings and collaboration",
        "Creating and managing boards for remote projects",
        "Collaborating with team members across time zones",
        "Optimizing Trello for remote work productivity"
        ]
        },
        {
        title: "Trello for Marketing",
        content: [
        "Using Trello for marketing project management",
        "Creating and managing boards for content creation and promotion",
        "Collaborating with team members and stakeholders using Trello",
        "Using Trello for social media and email marketing",
        "Integrating Trello with marketing software and tools"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is Trello Training?',
        answer:
          'Trello Training is a specialized program designed to teach individuals how to effectively use Trello, a popular project management tool, for organizing tasks, collaborating with teams, and managing projects efficiently',
      },
      {
        question: 'Why is Trello Training important?',
        answer:
          'Trello Training is essential for individuals and teams seeking to maximize their productivity and streamline project workflows using Trello\'s features and functionalities',
      },
      {
        question: 'How does Trello work?',
        answer:
          'Trello uses a system of boards, lists, and cards to organize tasks and projects. Users can create boards for different projects, add lists to those boards for different stages of a project, and then add cards to those lists for specific tasks.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Trello skills can pursue a variety of career opportunities such as Project Manager, Product Manager, Content Manager, and Marketing Manager.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Trello at the Best Training Centre. Our comprehensive Trello training program welcomes learners from diverse backgrounds, regardless of prior experience with project management tools. Whether you're a project manager, team leader, entrepreneur, or anyone seeking to enhance productivity and collaboration using Trello, our courses cater to individuals at every proficiency level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Trello concepts, including board creation, task management, workflow optimization, and collaboration features. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in leveraging Trello for efficient project management. Join us and unlock your Trello mastery with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
     return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of project management and collaboration, Trello emerges as a beacon of efficiency and organization. It stands as a web-based platform designed to empower individuals and teams in orchestrating their tasks, projects, and workflows. What sets Trello apart is its intuitive visual interface, which employs boards, cards, and lists to create a seamless and visually intuitive organizational framework."/> */}
          <NewMainsec rating='4.7' students={"232"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of project management and collaboration, Trello emerges as a beacon of efficiency and organization. It stands as a web-based platform designed to empower individuals and teams in orchestrating their tasks, projects, and workflows. What sets Trello apart is its intuitive visual interface, which employs boards, cards, and lists to create a seamless and visually intuitive organizational framework."/>

        
          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location} - Course Overview`} content={`Trello, a popular project management and collaboration tool, has seen significant adoption in ${this.props.location1}, a bustling metropolitan city in India. The tool's intuitive interface, using boards, lists, and cards to organize tasks, benefits a diverse range of businesses from tech startups to large corporations. Trello is leveraged for applications like software development, marketing campaigns, event planning, and educational projects. The city's thriving IT sector particularly embraces Trello for enhancing team collaboration and streamlining workflow management. Local tech communities frequently hold workshops and meetups to share best practices, fostering a collaborative environment for maximizing Trello's potential.`} 
    		title={this.props.title} location={this.props.location} location1={this.props.location1} course={`
        Enroll in our Trello course in ${this.props.location1} for expert guidance on optimizing project management. Learn essential skills tailored to ${this.props.location1} dynamic business environment. Master Trello's features for streamlined workflow and enhanced collaboration. Join us to boost productivity and achieve your project goals efficiently.`}/>
          </section>

	          <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>

 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>    
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou="Jira Admin" coupath="jira-admin" cou1='Okta' coupath1='okta' cou2='Asana' coupath2='asana' cou3='SAP' coupath3='sap' cou4='Salesforce Administration' coupath4='salesforce-administration' cou5='Pega' coupath5='pega' cou6='Azure Administration' coupath6='azure-admin' 
         cou7='Scrum Master' coupath7='scrum-master' cou8='Dynamic365' coupath8='dynamic365' cou9='Bigfix' coupath9='bigfix'  cou10='Python' coupath10='python'/>
           
       
      </>
    );
  }
}
